import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {jobProfilesList_template} from "../components/templates/jobProfilesList_template";
import {header} from "./header";
import {insert} from "@amcharts/amcharts4/.internal/core/utils/Array";

declare var ko: any;
declare var page: any;

export class job_profiles extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: jobProfilesList_template;
    protected pagination: pagination_template;
    protected timer;

    protected getModuleName(){

        return "job_profiles";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        this.elementsList = new jobProfilesList_template("list", this.viewModel, this);
        this.template = this.elementsList;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Job Profiles");

        return [this.elementsList.build()];
    }

    public fillPage() : void{

        this.getfilterReference();
    }

    protected addJobProfile(){

        this.saveViewModule(this.getMemoryViewModel());
        page('/job/profiles/add');
    }

    protected paginationOnPageClick(){

        this.filterList();
    }

    protected jobProfileListReorder(){

        this.filterList();
    }

    protected filterDropdownOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterMultipleSelectorOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    public getfilterReference(): void{

        if( "getfilterReference" in this.XHRHdls ){
            this.XHRHdls["getfilterReference"].cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/job/references';
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdls['getfilterReference'] = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdls['getfilterReference'].onReadyStateFunction = this.onFilterReferenceRequestReturn;
        this.XHRHdls['getfilterReference'].execute();
    }

    protected onFilterReferenceRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.elementsList.setBrands(responseParsed.brands);
                obj.elementsList.setStatus([{'id':0, 'name': 'Disabled'}, {'id':1, 'name': 'Enabled'}]);
                obj.getSearchPresetsListData();
            });

        }
    }

    protected filterList(){

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/job/profiles/get/';
        this.timer = new Date().getTime();
        let subViewModel = this.elementsList.getViewModelForRequest();
        this.sendFilterCall(usrReq_url, subViewModel, this.onFilterRequestReturn, XMLHttpRequestHandler_requestType.GET, 'articles');
    }

    protected onFilterRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
                obj.updateViewModelFromPath();
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
            });
        }
    }

    protected filterBrandList(brand){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/brand/'+ brand.id+ '/job/profiles/get';
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterBrandRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterBrandRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                let profiles = responseParsed.data;
                for(let profile of profiles){
                    profile.isActive = ko.observable(profile.isActive == "1" ? true : false);
                }
                obj.elementsList.setSortables(profiles);
            });
            obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected updateList(responseParsed: any){

        this.elementsList.setProfiles(responseParsed.paginatedResults.data);

        let execTime = Math.round((new Date().getTime() - this.timer)/1000*100)/100;
        this.elementsList.setResultInfo(responseParsed.paginatedResults.totalCount, responseParsed.paginatedResults.totalPage,execTime );

        // update the paginator
        this.viewModel.list.pagination.itemCount(responseParsed.paginatedResults.totalCount);

        if(responseParsed.permissions.job_profiles.update){

            this.elementsList.setAddButtonShown(true);
        }
    }

    protected bulkSave(sortables) {

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        this.saveViewModule(this.getMemoryViewModel());

        let activeConfigBrand = this.getMemoryViewModel().activeConfigBrand()
        let formReq_url: string = '/api/brand/'+ activeConfigBrand.id +'/job/profiles/save/';

        let formReq_params: Array<Array<string>> = [];
        let subViewModel = JSON.parse(ko.toJSON(sortables));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    obj.elementsList.config.togglePopUp(false);
                    obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
                    page.redirect('/job/profiles');
                });
            }
        });
        XHRHdl.execute();
    }


    protected getSearchPresetsListData(): void {

        if( "getSearchPresetsListData" in this.XHRHdls ){
            this.XHRHdls["getSearchPresetsListData"].cancelAndReset();
        }

        let subViewModel = JSON.parse(ko.toJSON(this.elementsList.getViewModelForRequest()));
        let usrReq_url: string = '/api/search_preset/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['getSearchPresetsListData']= new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getSearchPresetsListData'].onReadyStateFunction = this.onGetSearchPresetsReturn;
        this.XHRHdls['getSearchPresetsListData'].execute();
    }

    protected onGetSearchPresetsReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.elementsList.setSearchPresets(response);
                obj.filterList();
            });
        }
    }

    protected saveSearchPreset(){

        if( "saveSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveSearchPreset"].cancelAndReset();
        }

        let formReq_url: string = '/api/search_preset/save';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.elementsList.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdls['saveSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveSearchPreset'].onReadyStateFunction = this.onSaveSearchPresetReturn;
        this.XHRHdls['saveSearchPreset'].execute();
    }

    private onSaveSearchPresetReturn(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.elementsList.addCreatedPresetToList(response);

            });

        }
    }

    protected saveFavoriteSearchPreset( params: {presetId: number, searchPresetType: string}): void {

        if( "saveFavoriteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveFavoriteSearchPreset"].cancelAndReset();
        }
        let formReq_url: string = '/api/search_preset/favorite/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(params));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['saveFavoriteSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveFavoriteSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveFavoriteSearchPreset'].onReadyStateFunction = this.onSaveFavoriteSearchPresetReturn
        this.XHRHdls['saveFavoriteSearchPreset'].execute();
    }

    private onSaveFavoriteSearchPresetReturn(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

            });
        }
    }

    protected deleteSearchPreset(presetId: number): void {

        if( "deleteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["deleteSearchPreset"].cancelAndReset();
        }

        let usrReq_url: string = '/api/search_preset/delete/' + presetId + '/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdls['deleteSearchPreset'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['deleteSearchPreset'].onReadyStateFunction = this.onDeleteSearchPresetReturn;
        this.XHRHdls['deleteSearchPreset'].execute();
    }

    protected onDeleteSearchPresetReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

            });
        }
    }

    protected setDefaultStatusFilters(){
        // no implementation for presist setSearchPresetsfunction
    }

    protected filterByUrl(){

        this.updateViewModelFromPath();
        this.filterList();
    }

    protected viewProfile(application){

        this.saveViewModule(this.getMemoryViewModel());

        let viewUrl = window.location.origin +'/job/profiles/view/' + application.id;
        let editUrl = window.location.origin +'/job/profiles/edit/' + application.id;
        this.savePreviousPage(viewUrl, window.location.href);
        this.savePreviousPage(editUrl, window.location.href);
        page('/job/profiles/view/'+ application.id);
    }

    protected filterByPresets(filters){

        this.elementsList.setViewModelFromRequest(filters);
        this.filterList();
    }

    protected getMemoryViewModel(){
        let templateViewModel = this.elementsList.getTemplateViewModel();

        delete templateViewModel.profiles;

        return templateViewModel;
    }

    public resetWebsiteConfigs(){

        this.elementsList.getTemplateViewModel().idBrand('');
    }

}


// WEBPACK FOOTER //
// ./js/modules/job_profiles.ts